import { render, staticRenderFns } from "./CurrentYear.vue?vue&type=template&id=987b679a&"
import script from "./CurrentYear.vue?vue&type=script&lang=js&"
export * from "./CurrentYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('987b679a')) {
      api.createRecord('987b679a', component.options)
    } else {
      api.reload('987b679a', component.options)
    }
    module.hot.accept("./CurrentYear.vue?vue&type=template&id=987b679a&", function () {
      api.rerender('987b679a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4HDnQ7pWvh0SR/JS/comp/CurrentYear.vue"
export default component.exports